export * from './incidents-v2-stats.component';
